import { render, staticRenderFns } from "./AddMobile.vue?vue&type=template&id=005e671e&scoped=true&"
import script from "./AddMobile.vue?vue&type=script&lang=js&"
export * from "./AddMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005e671e",
  null
  
)

export default component.exports